<template>
  <validation-provider
    :name="name"
    mode="eager"
    :rules="rules"
    v-slot="{ errors }"
  >
    <b-form-group :label="label">
      <b-form-checkbox-group
        :class="wrapperClass"
        :state="errors[0] ? false : null"
        :options="options"
        :name="name"
        @input="input"
        :checked="value"
        plain
      ></b-form-checkbox-group>
      <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
export default {
  props: {
    name: String,
    value: [String, Boolean, Number, Array],
    rules: String,
    label: String,
    options: Array,
    wrapperClass: {
      default: "",
      type: String,
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    input(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .bv-no-focus-ring {
    display: flex;
    justify-content: space-between;
    margin: rem(4px) 0;
    .form-check-inline {
      display: flex;
      align-items: center;
      margin: 0;
      &:not(:last-child) {
        margin-right: rem(16px);
      }
      .form-check-input {
        width: 21px;
        min-width: 21px;
        height: 21px;
        padding: 0;
        margin-top: 0;
        border: 2px solid #ccd4e0;
        cursor: pointer;
        &:checked {
          background-color: var(--primary);
          border-color: var(--primary);
        }
        &:focus {
          box-shadow: none;
        }
        &.is-invalid {
          border: 2px solid #dc3545;
        }
      }
      .form-check-label {
        margin-left: 10px;
        font-size: rem(16px);
        color: var(--textPrimary);
        cursor: pointer;
      }
    }
    &.col-form-label {
      font-size: rem(16px);
      font-weight: 500;
      padding-bottom: 12px;
    }
  }
}
.stacked-list {
  flex-direction: column;
  border: solid 1px #ccd4e0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  ::v-deep {
    .form-check {
      margin-right: 0 !important;
      padding-left: 0;

      input[type="checkbox"] {
        display: none;
        + label {
          display: block;
          line-height: normal;
          position: relative;
          font-size: rem(14px);
          color: #253858;
          width: 100%;
          margin-left: 0px !important;
          padding: 8px 0px;
          padding-left: 8px;
        }
        &:checked {
          + label {
            background: var(--primary);
            color: #fff;
          }
        }
      }
      &:not(:last-child) {
        border-bottom: solid 1px #ccd4e0;
      }
    }
  }
}
</style>
